import { createFileRoute } from "@tanstack/react-router"
import { Crumb } from "modules/shared/lib/breadcrumbs"

import "modules/conversations/lang"

export const Route = createFileRoute("/_base/_auth/conversations")({
  loader: ({ route: { fullPath } }) => {
    return new Crumb({
      fullPath,
      title: (t) => t("conversations.header.title"),
    })
  },
})
